import {
  TUpdateGeneralSettingsDTO,
  IUpdateGeneralSettingsResponse,
  TGetGeneralSettingsResponse,
  staticSettingsEndpoints,
} from '@/models/settings.model';
import { ApiResponse, httpClient } from '@/utils';

class SettingsAPI {
  static getGeneralSettings(): ApiResponse<TGetGeneralSettingsResponse> {
    const { GET_GENERAL_SETTINGS } = staticSettingsEndpoints;
    return httpClient.get<TGetGeneralSettingsResponse>(GET_GENERAL_SETTINGS);
  }

  static updateGeneralSettings(data: TUpdateGeneralSettingsDTO): ApiResponse<IUpdateGeneralSettingsResponse> {
    const { UPDATE_GENERAL_SETTINGS } = staticSettingsEndpoints;
    return httpClient.post<IUpdateGeneralSettingsResponse>(UPDATE_GENERAL_SETTINGS, data);
  }
}

export default SettingsAPI;
